import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    CardContentDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    concentric
} from "../../../../helpers/theme/concentric";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

export const CARD_MEDIA_ASPECT_RATIO = 16 / 9;

export const CARD_CONTENT_SKELETON_LINES = 2;

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        minWidth: 0
    },
    inert: {
        pointerEvents: "none"
    },
    edge: {
        overflow: "hidden"
    }
});

export const useStyles = ({
    shapeConfigs,
    radiuses,
    borders,
    isFlush,
    layout,
    spaces,
    inset
}: CardContentDynamicStyleType) => {
    const styles = {
        placeholder: {} as Mutable<ViewStyle>,
        container: {} as Mutable<ViewStyle>
    };

    if(!isFlush) {
        styles.container.paddingHorizontal = inset;

        styles.container.gap = spaces.spacingMd;

        return styles;
    }

    styles.placeholder.marginHorizontal = inset;

    if(layout.isDividedHeaderBefore) {
        styles.container.marginTop = -inset;
    }

    if(layout.isDividedFooterAfter) {
        styles.container.marginBottom = -inset;
    }

    const {
        borderRadius: edgeRadius,
        ...edgeShape
    } = getCornerStyle({
        radius: concentric({
            outer: radiuses.surface,
            role: radiuses.surface,
            inset: borders.line
        }),
        shapeConfigs
    });

    if(layout.isFirst) {
        Object.assign(styles.container, edgeShape, {
            borderTopStartRadius: edgeRadius,
            borderTopEndRadius: edgeRadius
        });
    }

    if(layout.isLast) {
        Object.assign(styles.container, edgeShape, {
            borderBottomStartRadius: edgeRadius,
            borderBottomEndRadius: edgeRadius
        });
    }

    return styles;
};
export default stylesheet;
